import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksProducts(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		options
	)
}

function _getOrderGeneratorsFieldsWorksProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
		options
	)
}

function _createOrderGeneratorsFieldsWorksProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
		options
	)
}

function _putOrderGeneratorsFieldsWorksProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksProduct(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS]: _getOrderGeneratorsFieldsWorksProducts,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: _getOrderGeneratorsFieldsWorksProduct,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: _createOrderGeneratorsFieldsWorksProduct,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: _putOrderGeneratorsFieldsWorksProduct,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: _patchOrderGeneratorsFieldsWorksProduct,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: _deleteOrderGeneratorsFieldsWorksProduct,
}